export default __webpack_public_path__ + "static/kurorty-img-9-5cf20bad7144a52120c70332f2d7bb24.png";